/**
 * ANX-056a — версия privacy policy и terms, на которую оператор Сервиса
 * соглашается при signup'е. Должна совпадать с landing/privacy.html и
 * widget/src/consent.ts CONSENT_VERSION. Backend хранит её как
 * непрозрачную строку (`operators.consent_version`).
 */
export const CONSENT_VERSION = '1.0';

export const PRIVACY_URL = 'https://anexica.com/privacy';
export const TERMS_URL = 'https://anexica.com/terms';
